import * as i from "react";
import { p as u } from "./index-efd35e77.js";
import { v as m, c as f, p as y } from "./package-metadata-9ad1330d.js";
var v = {
  button: "k-button",
  flat: "k-flat",
  outline: "k-outline",
  clear: "k-button-clear",
  primary: "k-primary",
  "state-selected": "k-selected",
  "button-icon": "k-button-icon",
  "button-icontext": "k-button-icontext",
  "state-disabled": "k-disabled",
  "group-start": "k-group-start",
  "group-end": "k-group-end",
  "button-group": "k-button-group",
  "button-group-stretched": "k-button-group-stretched",
  ltr: "k-ltr",
  rtl: "k-rtl"
}, g = ":not(.k-dropdownlist button):not(.k-colorpicker button):not(.k-split-button .k-split-button-arrow)", B = [
  "button" + g,
  ".k-button-group > button" + g,
  ".k-dropdownlist",
  ".k-colorpicker"
];
const k = {
  styles: v
};
var _ = globalThis && globalThis.__extends || function() {
  var a = function(o, t) {
    return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, e) {
      r.__proto__ = e;
    } || function(r, e) {
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }, a(o, t);
  };
  return function(o, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    a(o, t);
    function r() {
      this.constructor = o;
    }
    o.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}(), p = globalThis && globalThis.__assign || function() {
  return p = Object.assign || function(a) {
    for (var o, t = 1, r = arguments.length; t < r; t++) {
      o = arguments[t];
      for (var e in o)
        Object.prototype.hasOwnProperty.call(o, e) && (a[e] = o[e]);
    }
    return a;
  }, p.apply(this, arguments);
}, c = k.styles, N = (
  /** @class */
  function(a) {
    _(o, a);
    function o(t) {
      var r = a.call(this, t) || this;
      return r._element = null, m(y), r;
    }
    return o.prototype.render = function() {
      var t, r = this, e = this.mapButtons(this.props.children), n = f([c["button-group"]], (t = {}, t["k-disabled"] = this.props.disabled, t[c["button-group-stretched"]] = !!this.props.width, t), this.props.className), s = {
        className: n,
        style: { width: "".concat(this.props.width) },
        dir: this.props.dir,
        // Accessibility properties
        role: "group",
        "aria-disabled": this.props.disabled
      };
      return i.createElement("div", p({ ref: function(l) {
        r._element = l;
      } }, s, { className: n }), e);
    }, o.prototype.mapButtons = function(t) {
      var r = this, e = i.Children.count(t), n = this.props.dir !== void 0 ? this.props.dir === "rtl" : this._element && getComputedStyle(this._element).direction === "rtl" || !1;
      return i.Children.map(t, function(s, l) {
        return i.isValidElement(s) ? r.renderButton(s, l, l === e - 1, n) : s;
      });
    }, o.prototype.renderButton = function(t, r, e, n) {
      var s, l = f(t.props.className, (s = {}, s[c["group-start"]] = n ? e : r === 0, s[c["group-end"]] = n ? r === 0 : e, s)), d = p(p({}, this.props.width ? { width: this.props.width } : {}), t.props.style || {}), h = this.props.disabled || t.props.disabled, b = p(p(p(p({}, t.props), l ? { className: l } : {}), Object.keys(d).length ? { style: d } : {}), h !== void 0 ? { disabled: h } : {});
      return i.Children.count(t.props.children) > 0 ? i.cloneElement(t, b, t.props.children) : i.cloneElement(t, b);
    }, o.propTypes = {
      children: u.oneOfType([u.arrayOf(u.element), u.element]),
      className: u.string,
      disabled: u.bool,
      width: u.string,
      dir: u.string
    }, o;
  }(i.Component)
);
export {
  N as B,
  B as t
};
